import { useLazyQuery } from "@apollo/client/react";
import useTimeZone from "hooks/useTimeZone";
import { GetEngagedSites } from "./usageData.gql";

export default function useGetEngagedSites({ eventNames, startDate, endDate, threshold, onCompleted }) {
  const { overrideToSiteTimeZone } = useTimeZone();

  const [queryEngagedSites] = useLazyQuery(GetEngagedSites, {
    variables: {},
  });

  const getEngagedSites = () => {
    return queryEngagedSites({
      variables: {
        endDate: overrideToSiteTimeZone(endDate),
        eventNames,
        startDate: overrideToSiteTimeZone(startDate),
        threshold,
      },
    }).then((result) => onCompleted(result.data));
  };

  return { getEngagedSites };
}
